import React from 'react';

import CardHOC from './Components/CardHOC';
import Attachment from '../../../Types/Components/Attachment';

const AttachmentType = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <Attachment question={question} />
  </CardHOC>
}

export default AttachmentType;